<template>
    <td
        class="schedule-number-cell"
        :class="{ 'schedule-number-cell--wide': wide }"
    >
        <span v-if="fixed" class="cell-value fixed" :aria-label="ariaLabel">
            {{ modelValue ?? "—" }}
        </span>
        <input
            v-else
            type="number"
            :inputmode="inputmode"
            :min="min"
            :max="max"
            :step="step"
            :value="modelValue"
            :placeholder="prefix ? `${prefix}—` : '—'"
            :aria-label="label"
            @input="onInput"
            @focus="$event.target.select()"
        />
    </td>
</template>

<script>
export default {
    name: "ScheduleGridNumberCell",
    props: {
        modelValue: {
            type: Number,
            default: null,
        },
        label: {
            type: String,
            required: true,
        },
        fixed: {
            type: Boolean,
            default: false,
        },
        min: {
            type: Number,
            default: 0,
        },
        max: {
            type: Number,
            default: 366,
        },
        prefix: {
            type: String,
            default: "",
        },
        step: {
            type: String,
            default: "1",
        },
        wide: {
            type: Boolean,
            default: false,
        },
    },
    emits: ["update:modelValue"],
    computed: {
        ariaLabel() {
            return `${this.label}: ${this.modelValue ?? "not set"}`;
        },
        inputmode() {
            return this.step === "1" ? "numeric" : "decimal";
        },
    },
    methods: {
        onInput(event) {
            const raw = event.target.value;
            if (raw === "") {
                this.$emit("update:modelValue", null);
                return;
            }
            const parsed = Number(raw);
            if (!Number.isFinite(parsed)) {
                return;
            }
            const clamped = Math.min(this.max, Math.max(this.min, parsed));
            this.$emit("update:modelValue", clamped);
        },
    },
};
</script>
